export default "__VITE_ASSET__BDiEfFNa__"